module.exports = __webpack_public_path__ + "static/media/component.8e019ccd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/retained/component.png
// module id = 68
// module chunks = 0